module.exports = __webpack_public_path__ + "img/2026-calendarpromo.6aa3f1a1.jpg";